<template>
  <div class="addresses_wrapper">
		<el-form-item :label="$t('portal.di-zhi')" :required="required"></el-form-item>
		<div style="margin-top: -30px">
			<div class="addresses-model" v-for="(form, key, index) in addresses" :key="key">
				<el-form-item label :rules="rule['address']" :prop="name + 'address' + key">
					<region v-model="form['address']" @input="change"></region>
				</el-form-item>
				<div class="second-line">
					<el-form-item label :rules="rule['street_address']" :prop="name + 'street_address' + key" class="item-local">
						<el-input :placeholder="$t('portal.jie-dao')" v-model="form['street_address']" autocomplete="off" @change="change"></el-input>
					</el-form-item>
					<el-form-item style="margin-left: 5px" label label-width="0" :rules="rule['building_address']" :prop="name + 'building_address' + key" class="item-local">
						<el-input :placeholder="$t('portal.men-pai')" v-model="form['building_address']" autocomplete="off" @change="change"></el-input>
					</el-form-item>
					<div class="control" v-if="!single">
						<i class="el-icon-circle-plus-outline icon" @click="addItem(key)" v-if="dataLen.length - 1 == index"></i>
						<i class="el-icon-remove-outline icon" @click="removeItem(key)" v-if="dataLen.length != 1"></i>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import Region from '~/common/components/custom/Region.vue';
export default {
  components: {
    Region
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    model: {
      type: Object
    },
    name: {
      type: String
    },
    single:{
      type: [Boolean, undefined, null],
      default: () => false
    },
    rule: {
      /**
          * 局部校验 有可能三个输入框，有不同的校验要求，所以传入自定义的rule
         {
           placeholder: "地址",
           name: "addresses",
           span: 24,
           type: "addresses",
           rule: {
             address: [{required: true,message: '1233'}],
             street_address: [{required: true,message: '1233'}],
             building_address: [{required: true,message: '1233'}],
           }
         },
       */
      type: Object,
      default: v => {
        return {};
      }
    },
    required: {
      type: Boolean
    }
  },
  computed: {
    dataLen() {
      return Object.keys(this.addresses);
    }
  },
  data() {
    return {
      addresses: {
        0: {
          address: [],
          street_address: '',
          building_address: ''
        }
      },
      form: {}
    };
  },
  created() {},
  watch: {
    value:{
      immediate:true,
      handler:function(val) {
        if (!val || val.length < 1) {
          this.addresses = {
            0: {
              address: [],
              street_address: '',
              building_address: ''
            }
          };
          for (let k in this.model) {
            if (k.startsWith(this.name)) {
              this.$delete(this.model, k);
            }
          }
        } else {
          this.addresses = val
        }
      },
    },
    addresses: {
      immediate: true,
      deep: true,
      handler: function (val) {
        for (let key in val) {
          for (let label in val[key]) {
            if (Array.isArray(val[key][label])) {
              //校验数组会失败
              this.$set(this.model, this.name + label + key, JSON.stringify(val[key][label]));
            } else {
              this.$set(this.model, this.name + label + key, val[key][label]);
            }
          }
        }
      }
    }
  },
  methods: {
    addItem(key) {
      let item = {
        address: [],
        street_address: '',
        building_address: ''
      };
      this.$nextTick(() => {
        this.$set(this.addresses, `${Number(key) + 1}`, item);
      });
    },
    removeItem(key) {
      const len = this.dataLen.length;
      if (len === 1) {
        this.$message({
          message: this.$t('portal.zhi-shao-bao-liu-yi-tiao-shu-ju'),
          type: 'warning'
        });
        return false;
      }
      this.$nextTick(() => {
        this.$delete(this.addresses, key);
      });
    },
    change() {
      const arr = [];
      for (let k in this.addresses) {
        arr.push(this.addresses[k]);
      }
      this.$emit('input', arr);
    }
  }
};
</script>
<style>
.error-deal .el-col .addresses_wrapper .el-form-item__error {
	top: -26px;
}
</style>
<style lang="less" scoped>
/deep/ .item-local {
	flex: 1;
}
.icon {
	margin-left: 5px;
	color: @linkColor;
}
.second-line {
	display: flex;
	align-items: center;
}
.control {
	width: 40px;
	display: flex;
	align-items: center;
}
</style>